import { render, staticRenderFns } from "./PanControls.vue?vue&type=template&id=61c86c6c&"
import script from "./PanControls.vue?vue&type=script&lang=js&"
export * from "./PanControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports